import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';

const defaultThemeModeContext = {
    mode: 'light',
    toggleThemeMode: () => {},
    setMode: () => {}
};

const ThemeModeContext = createContext(defaultThemeModeContext);

export const useThemeMode = () => {
    return useContext(ThemeModeContext);
};

export const ThemeModeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        const savedMode = localStorage.getItem('themeMode');
        return savedMode || 'light';
    });

    useEffect(() => {
        localStorage.setItem('themeMode', mode);
    }, [mode]);

    const toggleThemeMode = () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    };

    const value = useMemo(
        () => ({
            mode,
            toggleThemeMode,
            setMode,
        }),
        [mode]
    );

    return (
        <ThemeModeContext.Provider value={value}>
            {children}
        </ThemeModeContext.Provider>
    );
};
